var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRuinbetLogo = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 100,
    viewBox: "0 0 350 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.0985 33.4739C52.5376 33.4739 58.5681 27.4201 58.5681 19.9523C58.5681 12.4845 52.5376 6.43066 45.0985 6.43066C37.6595 6.43066 31.6289 12.4845 31.6289 19.9523C31.6289 27.4201 37.6595 33.4739 45.0985 33.4739Z",
    fill: "#3892CF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M34.9102 14.7237C34.9102 13.2313 35.1297 11.789 35.5387 10.4268C37.9832 7.95286 41.3656 6.42041 45.0972 6.42041C52.5304 6.42041 58.5668 12.4701 58.5668 19.942C58.5668 23.2273 57.3994 26.2421 55.4538 28.5859C53.7177 29.297 51.822 29.6876 49.8265 29.6876C41.5851 29.6876 34.9102 22.9869 34.9102 14.7137V14.7237Z",
    fill: "url(#paint0_linear_10333_61105)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5629 75.0302C60.5629 75.0302 76.0778 57.0013 68.1058 47.9568C61.1016 40.0041 3.33203 30.2886 3.33203 30.2886C4.27989 46.8351 46.6742 68.1992 60.5529 75.0402L60.5629 75.0302Z",
    fill: "#054C72"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5629 75.0302C60.5629 75.0302 76.0778 57.0013 68.1058 47.9568C61.1016 40.0041 3.33203 30.2886 3.33203 30.2886C4.93841 43.1291 46.5146 68.8002 60.5529 75.0402L60.5629 75.0302Z",
    fill: "#3892CF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 30.2886C3.33203 30.2886 61.1016 40.0041 68.1058 47.9669C76.0679 57.0113 60.5629 75.0402 60.5629 75.0402C60.5629 75.0402 65.9008 57.1716 3.34201 30.2886H3.33203Z",
    fill: "url(#paint1_linear_10333_61105)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9063 78.1553L16.9609 58.9746C16.9609 58.9746 24.5039 83.594 40.857 95.5932C40.857 95.5932 50.7048 88.9125 58.9063 78.1553Z",
    fill: "#3892CF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9609 58.9746L58.9063 78.1553C58.5571 78.616 58.2078 79.0567 57.8486 79.5075C49.717 75.471 16.9609 58.9846 16.9609 58.9846V58.9746Z",
    fill: "#054C72"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9941 87.0593C28.7743 72.7163 16.9609 58.9844 16.9609 58.9844L58.9063 78.1651C56.3121 81.5705 53.5583 84.5653 50.9941 87.0693V87.0593Z",
    fill: "url(#paint2_linear_10333_61105)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M119.2 79.4472L112.375 65.8754H109.302V79.4472H97.0098V36.248H114.221C118.93 36.248 122.831 37.6403 125.905 40.4147C128.978 43.1892 130.514 46.865 130.514 51.4323C130.514 53.9864 129.935 56.2901 128.758 58.3434C127.591 60.3967 125.964 62.0694 123.869 63.3414L132.35 79.4472H119.19H119.2ZM109.302 47.5962V55.619H113.971C115.279 55.6591 116.316 55.3286 117.074 54.6275C117.833 53.9263 118.212 52.9448 118.212 51.6627C118.212 50.3807 117.833 49.3891 117.074 48.6679C116.316 47.9468 115.279 47.5862 113.971 47.5862H109.302V47.5962Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M166.533 76.232C163.301 79.0665 159.07 80.4888 153.872 80.4888C148.674 80.4888 144.443 79.0665 141.211 76.232C137.978 73.3874 136.352 69.6715 136.352 65.0641V36.3081H148.644V63.712C148.644 66.9171 150.38 68.5297 153.872 68.5297C157.364 68.5297 159.1 66.9271 159.1 63.712V36.3081H171.392V65.0641C171.392 69.6715 169.776 73.3974 166.533 76.232Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M178.766 36.3081H191.058V79.5072H178.766V36.3081Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M222.406 36.3081H234.698V79.5072H224.861L211.341 59.7556V79.5072H199.049V36.3081H208.887L222.406 56.0597V36.3081Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M270.359 57.2316C274.05 59.3249 275.896 62.52 275.896 66.7969C275.896 70.7432 274.619 73.8482 272.055 76.1118C269.491 78.3754 265.779 79.5072 260.9 79.5072H242.701V36.3081H259.793C264.632 36.3081 268.313 37.3598 270.858 39.4531C273.402 41.5565 274.669 44.5513 274.669 48.4676C274.669 52.3838 273.232 55.1282 270.369 57.2316H270.359ZM259.044 46.9251H254.983V52.7244L259.713 52.6643C261.479 52.4139 262.357 51.4724 262.357 49.8297C262.357 48.8882 262.028 48.1671 261.369 47.6663C260.711 47.1755 259.932 46.9251 259.034 46.9251H259.044ZM260.152 68.8902C261.14 68.8902 261.958 68.5998 262.606 68.0289C263.265 67.4479 263.594 66.7168 263.594 65.8053C263.594 64.0725 262.676 63.0709 260.83 62.7805L254.993 62.7204V68.8902H260.162H260.152Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M294.025 68.1491H310.009V79.5072H281.732V36.3081H309.699V47.5361H294.025V52.2236H308.163V63.3313H294.025V68.1491Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M346.895 36.3081V48.2773H336.748V79.5072H324.456V48.2773H314.309V36.3081H346.895Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M128.02 59.4653H97.0098V79.4473H109.302V65.8756H112.375L119.2 79.4473H132.36L123.879 63.3415C125.565 62.3099 126.942 61.0078 128.03 59.4653H128.02Z",
    fill: "#EAEAEA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M159.09 59.4653V63.7121C159.09 66.9173 157.344 68.5298 153.862 68.5298C150.38 68.5298 148.634 66.9273 148.634 63.7121V59.4653H136.342V65.0643C136.342 69.6717 137.958 73.3976 141.201 76.2322C144.434 79.0667 148.664 80.489 153.862 80.489C159.061 80.489 163.291 79.0667 166.524 76.2322C169.756 73.3876 171.383 69.6717 171.383 65.0643V59.4653H159.09Z",
    fill: "#EAEAEA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M191.058 59.4653H178.766V79.5074H191.058V59.4653Z",
    fill: "#EAEAEA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M199.049 59.4653V79.5074H211.341V59.7558L224.871 79.5074H234.708V59.4653H199.049Z",
    fill: "#EAEAEA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M242.701 59.4653V79.5074H260.9C265.779 79.5074 269.501 78.3756 272.055 76.112C274.619 73.8483 275.896 70.7434 275.896 66.7971C275.896 63.8223 274.988 61.3884 273.202 59.4653H242.701ZM262.616 68.029C261.958 68.61 261.14 68.8904 260.162 68.8904H254.993V62.7205L260.83 62.7806C262.676 63.0711 263.594 64.0727 263.594 65.8055C263.594 66.7069 263.265 67.4481 262.606 68.029H262.616Z",
    fill: "#EAEAEA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M294.025 63.3315H308.163V59.4653H281.732V79.5074H310.009V68.1492H294.025V63.3315Z",
    fill: "#EAEAEA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M336.749 59.4653H324.457V79.5074H336.749V59.4653Z",
    fill: "#EAEAEA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10333_61105",
    x1: 58.6566,
    y1: 7.18163,
    x2: 28.8871,
    y2: 34.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D1D1",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#797979",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#383838",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#101010",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#010101",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10333_61105",
    x1: 59.625,
    y1: 27.8447,
    x2: 22.602,
    y2: 60.7857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D1D1",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#797979",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#383838",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#101010",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#010101",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10333_61105",
    x1: 40.7572,
    y1: 63.9223,
    x2: 26.5094,
    y2: 87.1907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D1D1",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#797979",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#383838",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#101010",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#010101",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRuinbetLogo);
export default ForwardRef;